module.exports = __webpack_public_path__ + "img/photo-film-music.72b2f47d.svg";